import { StyleSystemProps } from '@withjoy/joykit';

const root: StyleSystemProps = {
  flexDirection: 'column',
  justifyContent: 'space-between',
  padding: 6,
  height: '100%',
  width: '100%',
  borderRadius: '12px',
  display: 'block'
};

export const styles = {
  root
};
